var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    _vm.computedInputType,
    _vm._g(
      _vm._b(
        { tag: "component", class: _vm.computedClass },
        "component",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [_vm._v(" " + _vm._s(_vm.computedValue) + " ")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }